import * as React from "react";

class IsReact {

    public classComponent(component: any) {
        return (
            typeof component === 'function' &&
            component.prototype &&
            !!component.prototype.isReactComponent
        );
    }

    // Ensure compatability with transformed code
    public functionComponent(component: any) {
        return (
            typeof component === 'function' &&
            String(component).includes('return') &&
            (
                String(component).includes('React.') ||
                String(component).includes('react.')
            ) &&
            String(component).includes('.createElement')
        );
    }

    public component(component: any) {
        return (
            this.classComponent(component) ||
            this.functionComponent(component)
        );
    }

    public element(typeElement: any) {
        return React.isValidElement(typeElement);
    }

    public DOMTypeElement(typeElement: any) {
        return this.element(typeElement) && typeof typeElement.type === 'string';
    }

    public compositeTypeElement(typeElement: any) {
        return this.element(typeElement) && typeof typeElement.type === 'function';
    }

    public compatible(item: any): boolean {
        return this.element(item) || this.component(item);
    }
}

export default new IsReact()
